module.exports = __webpack_public_path__ + "img/circle-question.4aaf57e5.svg";